import { render } from "./PetRequestsPage.vue?vue&type=template&id=0a025df2&scoped=true"
import script from "./PetRequestsPage.vue?vue&type=script&lang=js"
export * from "./PetRequestsPage.vue?vue&type=script&lang=js"

import "./PetRequestsPage.vue?vue&type=style&index=0&id=0a025df2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a025df2"]])

export default __exports__